// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h2NrlF {
  border: none;
  padding: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  left: auto;
  width: 400px;
  height: 100vh;
  min-height: 100vh;
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s) 0 0 var(--radius-s);
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  cursor: default;
  z-index: 1300;
}

.h2NrlF:focus {
  outline: none;
}

.h2NrlF::backdrop {
  background: var(--neutral-dark-opacity-50);
}

.h2NrlF[open] {
  margin: 0;
  height: 100vh;
  min-height: 100vh;
}

.UytCuj {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

.uYKtxY {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: var(--spacing-1);
  padding: var(--spacing-3) var(--spacing-3) 0 var(--spacing-3);
}

.mKXPDd {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.sys_7H {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
}

.pws3nW {
  width: 16px;
  height: 16px;
}

.TWYYlG {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  width: 100%;
  background: var(--surface-neutral-white);
  padding: var(--spacing-3);
  gap: var(--spacing-3);
}

.hQfIZI {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-1);
}

.Pwohjj {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: var(--spacing-1-5);
}

.UfLUgs {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  text-align: left;
}

.z_Bh_3 {
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
}

.qdXrvP {
  width: 100%;
}

.VPc5Bo {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/ExportExtract/ExportExtract.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,wCAAwC;EACxC,kDAAkD;EAClD,2CAA2C;EAC3C,sBAAsB;EACtB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,OAAO;EACP,WAAW;EACX,wCAAwC;EACxC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".modal {\n  border: none;\n  padding: 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: auto;\n  width: 400px;\n  height: 100vh;\n  min-height: 100vh;\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s) 0 0 var(--radius-s);\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.08);\n  box-sizing: border-box;\n  cursor: default;\n  z-index: 1300;\n}\n\n.modal:focus {\n  outline: none;\n}\n\n.modal::backdrop {\n  background: var(--neutral-dark-opacity-50);\n}\n\n.modal[open] {\n  margin: 0;\n  height: 100vh;\n  min-height: 100vh;\n}\n\n.content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-1);\n  padding: var(--spacing-3) var(--spacing-3) 0 var(--spacing-3);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n}\n\n.chevronLeft {\n  width: 16px;\n  height: 16px;\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex: 1;\n  width: 100%;\n  background: var(--surface-neutral-white);\n  padding: var(--spacing-3);\n  gap: var(--spacing-3);\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-1);\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  gap: var(--spacing-1-5);\n}\n\n.label {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  text-align: left;\n}\n\n.footer {\n  position: sticky;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n}\n\n.button {\n  width: 100%;\n}\n\n.loading {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `h2NrlF`,
	"content": `UytCuj`,
	"header": `uYKtxY`,
	"title": `mKXPDd`,
	"closeButton": `sys_7H`,
	"chevronLeft": `pws3nW`,
	"body": `TWYYlG`,
	"column": `hQfIZI`,
	"row": `Pwohjj`,
	"label": `UfLUgs`,
	"footer": `z_Bh_3`,
	"button": `qdXrvP`,
	"loading": `VPc5Bo`
};
module.exports = ___CSS_LOADER_EXPORT___;
